module.exports = __webpack_public_path__ + "img/background_letter.1691cb60.png";